import React from 'react';

const Icon = ({ size = '50', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 50 50" fill="none" {...other}>
            <g clipPath="url(#a)" stroke="black" strokeWidth="1.8">
                <path
                    clipRule="evenodd"
                    d="M25.066 5.361c3.75 0 7.145 1.52 9.602 3.978a13.537 13.537 0 0 1 3.977 9.602c0 3.75-1.52 7.145-3.977 9.602a13.537 13.537 0 0 1-9.602 3.978c-3.75 0-7.145-1.52-9.603-3.978a13.537 13.537 0 0 1-3.977-9.602c0-3.75 1.52-7.145 3.977-9.602a13.537 13.537 0 0 1 9.603-3.978Z"
                />

                <path
                    clipRule="evenodd"
                    d="M24.593 15.734c.885 0 1.687.36 2.267.94.58.58.94 1.381.94 2.267 0 .885-.36 1.687-.94 2.267-.58.58-1.382.94-2.267.94a3.196 3.196 0 0 1-2.268-.94 3.196 3.196 0 0 1-.939-2.267c0-.886.36-1.687.94-2.267.58-.58 1.381-.94 2.267-.94Z"
                />

                <path d="M25.706 15.26c.943-3.626 1.939-5.675 2.836-5.423 1.346.38 3.378 1.672 3.162 3.357-.182 1.427-1.876 3.453-3.94 5.172m-.331 2.514c3.157 2.017 4.798 3.598 4.28 4.373-.776 1.163-2.633 2.696-4.17 1.97-1.3-.614-2.704-2.85-3.7-5.344m-2.831-1.717c-3.463 1.429-5.7 1.867-6.038.998-.507-1.303-.697-3.704.778-4.546 1.25-.713 3.887-.58 6.501.034m.549 15.118-1.438 7.748m5.966-7.748 1.478 7.673" />

                <path d="M34.119 35.537v2.869" strokeLinecap="round" />

                <rect x="10.877" y="39.455" width="28.377" height="4.235" rx="2.118" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill={fill} d="M.924.834h48.284v48.284H.924z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
